<template>
  <footer>
    <section class="footer-one">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-xl-3 footer-item">
            <h2>{{getData('texts', 'contacts')}}</h2>
            <div class="contacts-list">
              <a v-bind:href="'mailto:' + getData('contacts', 'email')" class="mail-link">{{getData('contacts', 'email')}}</a>
              <a v-bind:href="'tel:' + getData('contacts', 'telephone')" class="tel-link">{{getData('texts', 'telephone')}} {{getData('contacts', 'telephone')}}</a>
              <a href="#" class="location-link">{{getData('contacts', 'address')}}</a>
            </div>
          </div>
          <div class="col-sm-6 col-xl-4 footer-item">
            <h2>{{getData('texts', 'information')}}</h2>
            <ul class="info-footer-list p-0">
              <li><router-link v-bind:to="'/' + $root.locale">{{getData('links', 'home')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/about-us'">{{getData('links', 'about')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/industry'">{{getData('links', 'industry')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/complex'">{{getData('links', 'complex')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/vacancy'">{{getData('links', 'vacancy')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/contacts'">{{getData('links', 'contacts')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/news'">{{getData('links', 'news')}}</router-link></li>
            </ul>
          </div>
          <div class="col-sm-6 col-xl-2 footer-item">
            <h2>{{getData('links', 'services')}}</h2>
            <ul class="usefull-footer-list p-0">
              <li><router-link v-bind:to="'/' + $root.locale + '/freight-transport'">{{getData('services', 'transport')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/rail-freight'">{{getData('services', 'rail')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/air-freight'">{{getData('services', 'air')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/sea-freight'">{{getData('services', 'sea')}}</router-link></li>
              <li><router-link v-bind:to="'/' + $root.locale + '/additional-services'">{{getData('services', 'add')}}</router-link></li>
            </ul>
          </div>
          <div class="col-sm-6 col-xl-3 footer-item">
            <h2>{{getData('texts', 'subscribe')}}</h2>
            <div class="subscribe-form">
              <form @submit="subcribe">
                <input type="email" name="email" v-model="email" v-bind:placeholder="getData('texts', 'placeholder')" required="" class="subscribe-name" />
                <div v-for="error in errors" class="error">{{error}}</div>
                <div v-if="success" class="success">{{success}}</div>
                <div class="subscribe-btn">
                  <input type="submit" v-bind:value="getData('texts', 'submit')">
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="footer-two">
      <div class="container d-flex justify-content-between">
        <div class="copyright-text">{{getData('texts', 'copyright')}}</div>
        <div class="social-bar-footer d-flex">
          <span>{{getData('texts', 'social')}}</span>
          <ul class="social-icon-list d-flex p-0 m-0">
            <li>
              <a v-bind:href="getData('socials', 'linkedin')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16"><defs><path id="dsvds" d="M1511.203 8513.212h3.651v10.776h-3.651zm3.892-3.334c0 1.035-.793 1.863-2.066 1.863h-.025c-1.224 0-2.016-.828-2.016-1.863 0-1.056.816-1.86 2.065-1.86s2.017.804 2.042 1.86zm12.924 14.11h-3.65v-5.765c0-1.449-.529-2.436-1.85-2.436-1.009 0-1.61.665-1.874 1.309-.096.23-.12.552-.12.874v6.018h-3.65s.047-9.765 0-10.776h3.65v1.526c.486-.734 1.353-1.78 3.291-1.78 2.402 0 4.203 1.541 4.203 4.851zm-7.494-9.213v-.037c-.007.013-.016.024-.024.037z"/></defs><g><g transform="translate(-1511 -8508)"><use fill="#333" xlink:href="#dsvds"/></g></g></svg>
              </a>
            </li>
            <li>
              <a v-bind:href="getData('socials', 'fb')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9" height="19" viewBox="0 0 9 19"><defs><path id="ucjda" d="M1451.988 8525.013H1448v-9.502h-1.992v-3.274h1.992v-1.965c0-2.671 1.125-4.26 4.323-4.26h2.662v3.275h-1.664c-1.245 0-1.326.458-1.326 1.31l-.006 1.64h3.015l-.352 3.274h-2.663v9.503z"/></defs><g><g transform="translate(-1446 -8506)"><use fill="#333" xlink:href="#ucjda"/></g></g></svg>
              </a>
            </li>
            <!-- <li>
              <a v-bind:href="getData('socials', 'twitter')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="13" viewBox="0 0 17 13"><defs><path id="gjfod" d="M1491.002 8510.792c-.64.27-1.894.381-2.482.415 1.065-.548 1.612-1.19 1.87-1.956-.667.375-1.494.54-2.282.688-.63-.638-1.44-.928-2.435-.928-1.908 0-3.455 1.469-3.455 3.28 0 .257.03.507.09.747-2.873-.137-5.42-1.442-7.124-3.426a3.137 3.137 0 0 0-.468 1.648c0 1.138 1.37 2.25 2.298 2.838-.567-.017-1.86-.272-2.326-.518v.041c0 1.589 1.922 2.942 3.503 3.243-.29.075-1.326.088-1.642.088-.222 0-.439-.021-.65-.059.44 1.304 1.716 2.25 3.228 2.278a7.174 7.174 0 0 1-4.292 1.404c-.279 0-.553-.016-.824-.046 1.53.93 3.346 1.473 5.298 1.473 6.356 0 9.832-4.997 9.832-9.33 0-.143.056-.042.049-.182.675-.462 1.349-1.04 1.812-1.698z"/></defs><g><g transform="translate(-1474 -8509)"><use fill="#333" xlink:href="#gjfod"/></g></g></svg>
              </a>
            </li> -->
            <li>
              <a v-bind:href="getData('socials', 'instagram')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19" height="19" viewBox="0 0 19 19"><defs><path id="dqwwqw" d="M1567 8511.243v8.514a5.25 5.25 0 0 1-5.244 5.243h-8.513a5.25 5.25 0 0 1-5.243-5.243v-8.514a5.25 5.25 0 0 1 5.243-5.244h8.513a5.25 5.25 0 0 1 5.244 5.244zm-1.686 8.514v-8.514a3.562 3.562 0 0 0-3.558-3.558h-8.513a3.562 3.562 0 0 0-3.557 3.558v8.514a3.562 3.562 0 0 0 3.557 3.557h8.513a3.562 3.562 0 0 0 3.558-3.557zm-2.918-4.257a4.9 4.9 0 0 1-4.896 4.895 4.901 4.901 0 0 1-4.896-4.895c0-2.7 2.196-4.896 4.896-4.896 2.7 0 4.896 2.197 4.896 4.896zm-1.686 0c0-1.77-1.44-3.21-3.21-3.21s-3.21 1.44-3.21 3.21 1.44 3.21 3.21 3.21 3.21-1.44 3.21-3.21zm2.765-5.963c.23.229.362.548.362.874 0 .325-.131.643-.362.874-.23.23-.548.362-.874.362-.325 0-.644-.132-.873-.362-.23-.23-.363-.55-.363-.874a1.241 1.241 0 0 1 1.236-1.236c.326 0 .645.131.874.362z"/></defs><g><g transform="translate(-1548 -8506)"><use fill="#333" xlink:href="#dqwwqw"/></g></g></svg>
              </a>
            </li>
           <!-- <li>
              <a v-bind:href="getData('socials', 'pinterest')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="20" viewBox="0 0 16 20"><defs><path id="vegds" d="M1595.472 8505.929c-5.5 0-8.274 3.943-8.274 7.231 0 1.992.754 3.763 2.371 4.423.265.108.503.004.58-.29.053-.202.18-.715.236-.929.078-.29.048-.391-.166-.645-.467-.55-.765-1.261-.765-2.27 0-2.926 2.19-5.545 5.7-5.545 3.11 0 4.817 1.9 4.817 4.436 0 3.338-1.477 6.156-3.67 6.156-1.211 0-2.118-1.001-1.827-2.23.348-1.467 1.022-3.049 1.022-4.109 0-.947-.509-1.737-1.561-1.737-1.238 0-2.233 1.28-2.233 2.997 0 1.093.37 1.832.37 1.832l-1.49 6.308c-.442 1.872-.066 4.168-.035 4.399.019.137.195.17.276.067.113-.149 1.588-1.97 2.09-3.79.142-.514.814-3.181.814-3.181.402.768 1.578 1.443 2.828 1.443 3.721 0 6.246-3.393 6.246-7.934 0-3.434-2.908-6.632-7.329-6.632z"/></defs><g><g transform="translate(-1587 -8506)"><use fill="#333" xlink:href="#vegds"/></g></g></svg>
              </a>
            </li> -->
          </ul>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Footer',

  data() {
    return {
      email: '',
      success: '',
      errors: []
    }
  },

  methods: {
    getData(key, field) {
      if (this.$root.hfInfo[key] && this.$root.hfInfo[key][field])
        return this.$root.hfInfo[key][field]
      return ''
    },

    subcribe(event) {
      event.preventDefault()

      let self = this

      this.success = ''
      this.errors = []

      $.ajax({
        method: 'post',
        url: '/static-assets/subscribe.php',
        data: {
          email: self.email
        },
        dataType: 'json'
      }).done(response => {
        if (response.success) {
          self.success = self.$root.hfInfo.texts.subscribesuccess;
          self.email = '';
        } else {
          console.log(self.$root.hfInfo.texts.subscribeerror);
          self.errors.push(self.$root.hfInfo.texts.subscribeerror);
        }
      }).fail(e => {
          self.errors.push(self.$root.hfInfo.subscribeerror);
      });
    }
  }
}

</script>
